import { render, staticRenderFns } from "./CreateLive.vue?vue&type=template&id=224763e8&scoped=true&"
import script from "./CreateLive.vue?vue&type=script&lang=js&"
export * from "./CreateLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224763e8",
  null
  
)

export default component.exports